import { Component, OnInit } from '@angular/core';

declare var Flickity: any;
@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css'],
})
export class TestComponent implements OnInit {
    flkty: any;
    flktyNav: any;
    currentIndex = 0;
    totalSlides = 0;

    constructor() {}

    ngOnInit(): void {
        this.initFlickity();
    }

    initFlickity() {
        this.flkty = new Flickity('#js-carousel-portadaImg', {
            cellSelector: '.js-carousel-cell',
            prevNextButtons: false,
            imagesLoaded: true,
            pageDots: true,
            autoPlay: false,
            lazyLoad: 1,
        });

        this.totalSlides = this.flkty.slides.length;

        this.flktyNav = new Flickity('#js-carousel-portada', {
            cellSelector: '.js-carousel-cell',
            prevNextButtons: true,
            imagesLoaded: true,
            pageDots: true,
            autoPlay: false,
            lazyLoad: 1,
            asNavFor: '#js-carousel-portadaImg',
        });

        this.flktyNav.on('change', (index) => {
            this.currentIndex = index;
            this.flkty.select(this.currentIndex);
        });
    }

    next() {
        if (this.currentIndex == this.totalSlides - 1) {
            this.flkty.select(0);
        } else {
            this.flkty.next();
        }
    }

    prev() {
        this.flkty.previous();
    }
}
